import { useState } from "react";

export function useSaveAttempted(submitCount: number): boolean {
  const [saveAttempted, setSaveAttempted] = useState(false);

  if (submitCount > 0 && !saveAttempted) {
    setSaveAttempted(true);
  }

  return saveAttempted;
}
